import { motion } from "framer-motion";
import { Gift, Moon, Check } from "lucide-react";

const EVENTS = [
    {
        id: "succuba",
        icon: Moon,
        title: "Cuore di Succuba — con l'autrice",
        desc: "Incontro con l'autrice a Torino e visita al Museo Egizio insieme.",
        day: 8,
        month: "nov",
        status: "coming",
    },
];

export default function Eventi() {
    return (
        <div data-testid="eventi-list">
            <div className="flex flex-col gap-5">
                {EVENTS.map((ev, i) => {
                    const done = ev.status === "done";
                    return (
                        <motion.article
                            key={ev.id}
                            className={`p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center gap-5 ${done ? "brass-frame bg-[rgba(255,246,224,0.45)]" : "parchment-card border-dashed opacity-80"}`}
                            initial={{ opacity: 0, y: 22 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.2 }}
                            transition={{ duration: 0.5, delay: i * 0.08 }}
                            data-testid={`event-card-${ev.id}`}
                        >
                            {done ? (
                                <div className="date-box next" data-testid={`event-date-${ev.id}`}>
                                    <span className="day">{ev.day}</span>
                                    <span className="month">{ev.month}</span>
                                </div>
                            ) : (
                                <div className="date-box" data-testid={`event-date-${ev.id}`}>
                                    <span className="day">{ev.day || "–"}</span>
                                    <span className="month">{ev.month || "data"}</span>
                                </div>
                            )}
                            <div className="flex items-start gap-4 flex-1">
                                <span className="shrink-0 w-11 h-11 rounded-full border border-[#b08d57]/60 bg-[rgba(176,141,87,0.14)] flex items-center justify-center text-[#7a5a2e]">
                                    <ev.icon size={20} strokeWidth={1.5} />
                                </span>
                                <div>
                                    <h3 className="f-title text-lg sm:text-xl text-[#3f2a12] leading-snug">{ev.title}</h3>
                                    <p className="f-body italic text-[#6d5638] mt-1 text-sm sm:text-base">{ev.desc}</p>
                                </div>
                            </div>
                            {done ? (
                                <span className="badge badge-done self-start sm:self-center">
                                    <Check size={12} /> Svolto
                                </span>
                            ) : (
                                <span className="badge badge-proposal self-start sm:self-center">In programma</span>
                            )}
                        </motion.article>
                    );
                })}
            </div>
            <p className="f-body italic text-[#6d5638] text-center mt-10 text-base" data-testid="eventi-note">
                Gli eventi speciali sono le serate fuori dalle letture mensili: feste, letture alla candela, ospiti a sorpresa.
            </p>
        </div>
    );
}
